<template>
  <div>
    <el-table
      :data="zoneList"
      border
      size="small"
      :style="`width: ${zoneListTableWidth}`"
      @sort-change="changeSort"
      :default-sort="
        sortData.order == ''
          ? {}
          : { prop: sortData.prop, order: sortData.order }
      "
    >
      <el-table-column prop="id" label="ID" align="center" width="70">
      </el-table-column>

      <el-table-column label="合区状态" align="center" width="140">
        <template slot-scope="scope">
          <span>{{
            scope.row.isMerging
              ? scope.row.mergingIntoZoneId == 0
                ? "合区中..."
                : "正在合入至" + scope.row.mergingIntoZoneId + "区..."
              : ""
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="包含子分区" align="center" width="100">
        <template slot-scope="scope">
          <span v-if="scope.row.childZoneNumber > 0"
            >{{ scope.row.childZoneNumber
            }}<a
              style="text-decoration: none"
              @click="openChildZonePageDialog(scope.row)"
              href="javascript:;"
            >
              [详情]</a
            ></span
          >
        </template>
      </el-table-column>
      <el-table-column
        prop="name"
        label="名称"
        align="center"
        width="120"
      ></el-table-column>
      <el-table-column label="被冠名" align="center" width="60">
        <template slot-scope="scope">
          <span>{{ scope.row.isNamedByPlayer ? "是" : "" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="标记为新区" align="center" width="60">
        <template slot-scope="scope">
          <span>{{ scope.row.isNew ? "是" : "" }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" width="100">
        <template slot="header">
          <span>名义开服日期</span>
          <div>
            <el-tooltip effect="dark" placement="top">
              <div slot="content">
                某些活动（比如各种“开服活动”）会被配置为相对该日期来算第几天开始和结束
              </div>
              <span
                ><i class="el-icon-question" style="font-size: 1.2em"></i
              ></span>
            </el-tooltip>
          </div>
        </template>
        <template slot-scope="scope">
          <span>{{ ms2day(scope.row.openAt) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="自动解除隐藏" align="center" width="130">
        <template slot-scope="scope">
          <span>{{ ms2ymdhm(scope.row.autoVisibleAfter) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="minVersion" align="center" width="100">
        <template slot="header">
          <span>游戏最低版本</span>
          <div>
            <el-tooltip effect="dark" placement="top">
              <div slot="content">低于该版本将看不到当前分区</div>
              <span
                ><i class="el-icon-question" style="font-size: 1.2em"></i
              ></span>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>

      <el-table-column
        v-if="!$bizutil.isCloudNative()"
        label="对外地址"
        align="center"
        width="80"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span>{{
            scope.row.mergedIntoZoneId > 0
              ? `( ${scope.row.address} )`
              : scope.row.address
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        v-if="!$bizutil.isCloudNative()"
        label="反向代理地址"
        align="center"
        width="80"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span>{{
            scope.row.mergedIntoZoneId > 0
              ? `( ${scope.row.proxyAddress} )`
              : scope.row.proxyAddress
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        v-if="!$bizutil.isCloudNative()"
        label="对内GRPC地址"
        align="center"
        width="80"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span>{{
            scope.row.mergedIntoZoneId > 0
              ? `( ${scope.row.internalAddress} )`
              : scope.row.internalAddress
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="状态" align="center" width="70">
        <template slot-scope="scope">
          <span
            v-if="scope.row.status == 0"
            class="zone-status-tag zone-status-tag-offline"
            >隐藏</span
          >
          <span
            v-else-if="scope.row.status == 1"
            class="zone-status-tag zone-status-tag-maintained"
            >维护</span
          >
          <span
            v-else-if="scope.row.status == 2"
            class="zone-status-tag zone-status-tag-idle"
            >流畅</span
          >
          <span
            v-else-if="scope.row.status == 3"
            class="zone-status-tag zone-status-tag-full"
            >爆满</span
          >
        </template>
      </el-table-column>
      <el-table-column
        prop="isHealth"
        sortable
        label="健康"
        align="center"
        width="70"
      >
        <template slot="header">
          <span>健康</span>
        </template>
        <template slot-scope="scope">
          <span v-if="scope.row.isHealth">
            <i
              class="el-icon-round"
              style="
                background-color: rgb(73, 243, 73);
                margin-right: 3px;
                border: 1px solid rgb(27, 4, 14);
              "
            ></i>
          </span>
          <span v-else>
            <i
              class="el-icon-round"
              style="
                background-color: rgb(255, 65, 65);
                margin-right: 3px;
                border: 1px solid rgb(27, 4, 14);
              "
            ></i>
          </span>
        </template>
      </el-table-column>
      <el-table-column
        v-if="$bizutil.hasAnyPrivilege(['zone'])"
        label="操作"
        align="center"
        width="130"
      >
        <template slot-scope="scope">
          <span
            class="link-button"
            @click="deleteZone(scope.row.id, scope.row.name)"
            >删除</span
          >
          <span class="link-button" @click="openEditZoneDialog(true, scope.row)"
            >复制</span
          >
          <span
            class="link-button"
            @click="openEditZoneDialog(false, scope.row)"
            >修改</span
          >
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
const axios = require("axios");
const util = require("@/util");
import bizutil from "@/bizutil";
const dialogutil = require("@/dialogutil");

import EditZoneDialog from "../EditZoneDialog";
import ChildZoneListPageDialog from "../ChildZoneListPageDialog";

export default {
  data() {
    return {
      tabValue: "zoneState",
      zoneList: [], // 分区列表数据

      sortData: {
        order: "",
        prop: "",
      },
    };
  },

  async created() {
    let orderBy = this.$route.query.orderBy;
    if (orderBy != null) {
      let arr = orderBy.split(",");
      let prop = this.$route.query.prop;
      this.sortData.order = arr[1];
      this.sortData.prop = arr[0];
    } else {
      this.sortData.order = "";
      this.sortData.prop = "";
    }
    // 拉取分区集合
    this.loadZoneList();
  },

  components: {
    EditZoneDialog,
    ChildZoneListPageDialog,
  },

  computed: {
    /**
     * 用于展示zone集合的table的宽度
     */
    zoneListTableWidth() {
      let px = 1391;

      if (!this.$bizutil.hasAnyPrivilege(['zone'])) {
        px -= 130;
      }

      if (this.$bizutil.isCloudNative()) {
        px -= 240;
      }

      return `${px}px`;
    }
  },

  methods: {
    /**
     * 切换tab
     */
    async switchTabs(tab, event) {
      switch (tab.name) {
        case "zoneList": {
          this.loadZoneList();
          break;
        }
      }
    },
    /**
     * 查询分区集合
     */
    async loadZoneList() {
      let resData = (
        await axios.post(
          `${util.getBackendApiBase()}/v1/admin/getZoneList`,
          {},
          {
            headers: {
              token: bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message.error(resData.message);
        return;
      }

      let listInResponse = resData.data.zones || [];

      // 排序（按分区id倒序排列）
      listInResponse.sort((x, y) => {
        return y.id - x.id;
      });

      this.zoneList = listInResponse;
    },

    /**
     * 删除一个分区
     * @param {*} id
     * @param {*} name
     */
    async deleteZone(id, name) {
      try {
        // 弹确认框
        await this.$confirm(`确认删除分区“${name}”？`);

        let resData = (
          await axios.post(
            `${util.getBackendApiBase()}/v1/admin/deleteZone`,
            {
              id: id,
            },
            {
              headers: {
                token: bizutil.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message.error(resData.message);
          return;
        }

        this.$message({
          message: "删除成功",
          type: "success",
        });

        for (let i = 0; i < this.zoneList.length; i++) {
          if (this.zoneList[i].id == id) {
            this.zoneList.splice(i, 1);
            break;
          }
        }
      } catch (e) {}
    },

    async openEditZoneDialog(isCreate, oldData) {
      this.$dialogutil.open("EditZoneDialog", {
        closedCallback: () => {
          this.loadZoneList();
        },
        data: {
          value: {
            isCreate: isCreate,
            oldData: oldData,
          },
        },
      });
    },

    async openChildZonePageDialog(entry) {
      this.$dialogutil.open("ChildZoneListPageDialog", {
        closedCallback: () => {
          this.loadZoneList();
        },
        data: { masterZoneId: entry.id },
      });
    },

    // 改变排序规则
    changeSort(e) {
      console.log(" this.$router:", this.$router);
      let orderBy = null;
      if (e.order != null) {
        orderBy = e.prop + "," + e.order;
      }

      this.$router.replace({
        orderBy: "",
        query: {
          orderBy: orderBy,
        },
      });
      /**  兼容性好*/
      window.location.reload();
    },

    ms2day(ts) {
      return util.ms2day(ts);
    },

    ms2ymdhm(ts) {
      return util.ms2ymdhm(ts);
    },
  },
};
</script>

<style lang="scss" scoped>
.zone-status-tag {
  display: inline-block;
  padding: 0 10px;
  border: 1px solid #d9ecff;
  border-radius: 4px;
}

.zone-status-tag-maintained {
  background-color: lightgray;
  border-color: lightgray;
}

.zone-status-tag-idle {
  background-color: chartreuse;
  border-color: chartreuse;
}

.zone-status-tag-full {
  background-color: rgb(243, 159, 159);
  border-color: red;
}

.el-icon-round {
  border-radius: 50%;
  width: 10px;
  height: 10px;
}

.link-button {
  padding-left: 10px;
  color: rgb(37, 148, 240);
  cursor: pointer;
}

::v-deep .el-table__row td {
  padding: 3px 0;
}

::v-deep .el-table .cell {
  line-height: 18px;
}
</style>